import { mutation } from "@/services/lukita";
import { gql } from "@urql/core";

export default function createProjectMutation(name, accountId) {
  return mutation(
    gql`
      mutation CreateProjectMutation($input: CreateProjectInput!) {
        createProject(input: $input) {
          project {
            __typename
            id
            slug
            name
            status
            createdAt
          }
        }
      }
    `,
    { input: { name, accountId } },
  );
}
